import React from 'react';
import OrgTripCard from './orgTripCard/OrgTripCard';

const OrgTripList = ({ data = [], onSelect, onEdit, onDuplicate, onDelete, onInactive, selectedStatus }) => {
    const handleSelect = (id) => {
        onSelect?.(id);
    };

    return (
        <div>
            {selectedStatus === 'rejected' && (
                <div className='note-section'>
                    <p>
                        Note:{' '}
                        <span>
                            Click on the package to view the rejection comment. You can edit and resubmit the package.
                        </span>
                    </p>
                </div>
            )}
            {Array.isArray(data) &&
                data.length > 0 &&
                data.map((item, index) => {
                    return (
                        <OrgTripCard
                            key={item._id}
                            dataItem={item}
                            onSelect={handleSelect}
                            onEdit={onEdit}
                            onDuplicate={onDuplicate}
                            selectedStatus={selectedStatus}
                            onDelete={onDelete}
                            onInactive={onInactive}
                        />
                    );
                })}
        </div>
    );
};

export default OrgTripList;
